<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToggle } from '@vueuse/core';
import { useStoreGetters, useMapGetter } from 'dashboard/composables/store';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import CampaignList from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignList.vue';
import WhatsAppEvoCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/WhatsAppEvoCampaign/WhatsAppEvoCampaignDialog.vue';
import ConfirmDeleteCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/ConfirmDeleteCampaignDialog.vue';
import WhatsAppEvoCampaignEmptyState from 'dashboard/components-next/Campaigns/EmptyState/WhatsAppEvoCampaignEmptyState.vue';

const { t } = useI18n();
const getters = useStoreGetters();

const selectedCampaign = ref(null);
const [showWhatsAppEvoCampaignDialog, toggleWhatsAppEvoCampaignDialog] =
  useToggle();

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isFetchingCampaigns = computed(() => uiFlags.value.isFetching);

const confirmDeleteCampaignDialogRef = ref(null);

const WhatsAppEvoCampaigns = computed(
  () => getters['campaigns/getWhatsAppEvoCampaigns'].value
);

const hasNoWhatsAppEvoCampaigns = computed(
  () => WhatsAppEvoCampaigns.value?.length === 0 && !isFetchingCampaigns.value
);

const handleDelete = campaign => {
  selectedCampaign.value = campaign;
  confirmDeleteCampaignDialogRef.value.dialogRef.open();
};
</script>

<template>
  <CampaignLayout
    :header-title="t('CAMPAIGN.WHATSAPP_EVO.HEADER_TITLE')"
    :button-label="t('CAMPAIGN.WHATSAPP_EVO.NEW_CAMPAIGN')"
    @click="toggleWhatsAppEvoCampaignDialog()"
    @close="toggleWhatsAppEvoCampaignDialog(false)"
  >
    <template #action>
      <WhatsAppEvoCampaignDialog
        v-if="showWhatsAppEvoCampaignDialog"
        @close="toggleWhatsAppEvoCampaignDialog(false)"
      />
    </template>
    <div
      v-if="isFetchingCampaigns"
      class="flex items-center justify-center py-10 text-n-slate-11"
    >
      <Spinner />
    </div>
    <CampaignList
      v-else-if="!hasNoWhatsAppEvoCampaigns"
      :campaigns="WhatsAppEvoCampaigns"
      @delete="handleDelete"
    />
    <WhatsAppEvoCampaignEmptyState
      v-else
      :title="t('CAMPAIGN.WHATSAPP_EVO.EMPTY_STATE.TITLE')"
      :subtitle="t('CAMPAIGN.WHATSAPP_EVO.EMPTY_STATE.SUBTITLE')"
      class="pt-14"
    />
    <ConfirmDeleteCampaignDialog
      ref="confirmDeleteCampaignDialogRef"
      :selected-campaign="selectedCampaign"
    />
  </CampaignLayout>
</template>
